<template>
  <div
    v-if="readyToShow"
    class="step package-step">
    <div
      class="go-to-back"
      @click="goToBack">&lt;</div>
    <div
      v-if="userPlan"
      class="choose">
      <h3>You already have a plan</h3>
      <div class="packages">
        <div class="package-item">
          <PackageItem
            :months="userPlan.interval_count"
            :price="userPlan.amount"/>
        </div>
      </div>
    </div>
    <div
      v-else
      class="choose">
      <h3>Unlimited Access</h3>
      <p>And a blurb about what type of benefits upgrading <br>to paid gets you. Will go here.</p>
      <div class="packages">
        <div
          v-for="(plan, key) in plans.data"
          :key="key"
          :class="{highlight:selected === key}"
          class="package-item"
          @click="select(key)">
          <PackageItem
            :months="plan.interval_count"
            :price="plan.amount"/>
        </div>
      </div>
      <div class="validate-container">
        <div
          v-if="selected === 'error'"
          class="validate-container-text">Please Choose Package</div>
        <a
          href="#"
          class="package-continue"
          @click.prevent="goToSubscriptionForm">Continue</a>
      </div>
    </div>
  </div>
  <div
    v-else
    class="save-data-animation">
    <img :src="getImageUrl('/images/animations/saving.svg')">
  </div>
</template>
<script>
import PackageItem from "./PackageItem";
import profileMixin from "@/mixins/profileMixin";
import {mapActions, mapGetters} from "vuex";
import {fetchSubscription} from "../../../../store/modules/api/actions";

export default {
    components: {PackageItem},
    mixins: [profileMixin],

    data: () => ({
        readyToShow: false,
        userPlan: null,
        currentPlan: undefined,
        selected: undefined
    }),

    computed: {
        ...mapGetters(['user', 'plans', 'planId'])
    },

    created() {
        this.fetchPlansData();
    },

    methods: {
        ...mapActions(['fetchPlans', 'fetchSubscription']),

        fetchPlansData() {
            this.fetchPlans().then(() => {
                this.fetchSubscription(this.user.id).then(() => {
                    if(this.planId) {
                        this.userPlan = this.plans.data.find((item) => {
                            return item.id === this.planId.trim();
                        })
                    }
                    this.readyToShow = true
                });
            });
        },

        goToBack() {
            this.$emit('prevStep');
        },

        select(val) {
            this.selected = val;
            this.currentPlan = this.plans.data[val];
        },

        goToSubscriptionForm() {
            if (this.selected !== 'undefined') {
                this.$emit('nextStep', this.currentPlan)
            } else {
                this.selected = 'error';
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/RegimenChecker/steps/PackageStep.vue